import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {FormatNumber, API_URL, ImagesUrl, ServerUrl,  Token, config, schoolName} from '../component/include'

import Select from 'react-select'
import { formatGroupLabel, longDate} from '../component/globalFunction'
import { userToken } from '../component/authentication'

const DisplayStudentAttendance =()=> {
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState([])
    const [sqlQuery, setSqlQuery] = useState([]);
    
    const [examtype, setExamtype]=useState([])
const [isSubmitting, setIsSubmitting] = useState(false); 
    const [schoolInfo, setSchoolInfo]=useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
   
const [staff, setStaff] = useState([]);
    const [attendance, setAttendance] = useState({
       fromDate:'',
       toDate:'',
       examtype:[],
       staff:[]
    })

   
    const fetchStaff =()=>{
        setNotice({...notice, isLoading: true}) 
        var sql ="Select staffName, code, fileNo  from tbl_staff"
    
        const fd = new FormData();
        fd.append('jwt', Token); 
    fd.append("sql", sql);
    let url = ServerUrl+'/fetchBySql_controller'
    axios.post(url, fd, config).then(result=>{
        
    setStaff(result.data)
    })
    .catch((error)=>{
    Alerts('Error!', 'danger', error.message)
    }).finally(()=>{
        setNotice({...notice, isLoading: false})
        
    })
    }
      
        
        const handleSelect= (option, action)=>{
            setAttendance({...attendance, [action.name]:option});
            setErrors({...errors, [action.name]:''})
            if(action.name==='examtype'){
                getDaysBetween(option.startDate, option.endDate)
            }
            setResult('')
        }

        const handleChange=(event)=>{
            const {name, value} = event.target;
            setAttendance({...attendance, [name]:value})

            if(name==='fromDate'){
            getDaysBetween(value, attendance.toDate)
            }else if(name==='toDate'){
                getDaysBetween(attendance.fromDate, value)
            }

            setResult('')
            setErrors({...errors, [name]:''})
        }
       
        const getDaysBetween =(startDate, endDate)=>{
            const start = new Date(startDate)
            const end =  new Date(endDate)
        
            var result = []
            while (start <= end){
                result.push(new Date(start).toISOString().slice(0,10))
                start.setDate(start.getDate()+1)
            }
    
           
            let final =   'SELECT s.staffName, s.fileNo, sum(case when a.attendance  = "P" then 1 else 0 end) as P, sum(case when a.attendance  = "A" then 1 else 0 end) as A, sum(case when a.attendance  = "H" then 1 else 0 end) as H  from tbl_staff s, tbl_staff_attendance a where   s.code = a.staffCode and a.attendanceDate >= "'+startDate+'" and a.attendanceDate <= "'+endDate+'"'

            setSqlQuery(final)
        }
        
    
            const fetchResult =()=>{
                    var sql = sqlQuery

            if(attendance.staff.length!==0){
                sql = sql + '  and a.staffCode = "'+attendance.staff.value+'"'
            }
            
            sql = sql+ '  group by a.staffCode '
            
      setNotice({...notice, isLoading: true}) 
      const fd = new FormData();
      fd.append("sql", sqlQuery);
     let url = API_URL+'/exam/result/fetch_raw';
            axios.post(url, fd, config).then(result=>{
                if(result.data.data.length!==0){
                    setResult(result.data.data)
                    
        window.scrollTo({top:document.body.scrollHeight, left:0, behavior:'smooth'})
                }else{
                    Alerts('Info!', 'default', 'No record found for the selected criterials')
                }
                
            })
            .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false})
                
            })  
        } 
        
        const fetchExamType =()=>{

            var sql ="SELECT CONCAT(t.session, ' ', t.term) as exam, r.ID, r.code, r.startDate, r.endDate, r.nextTermBegin, t.code as ecode from tbl_result_attendance r, tbl_exam_type t where r.exam = t.code order by exam ASC" ;
            
            const fd = new FormData();
            fd.append("sql", sql);
            fd.append('jwt', Token)
            let url = ServerUrl+'/fetchBySql_controller';
            axios.post(url, fd, config).then(result=>{
                setExamtype(result.data)
            })
            .catch((error)=>{
                Alerts('Error!', 'danger', error.message)
            })
            }

            const validateInput =(values)=>{
                let errors = {};     
                
                if(values.examtype.length===0){
                    errors.examtype ='This field is required';
                }
                return errors;
                }
            
            

            const handleSubmit =(event)=>{
                event.preventDefault();
                setErrors(validateInput(attendance));
                setIsSubmitting(true);
            } 


            useEffect(()=>{
                if(Object.keys(errors).length === 0 && isSubmitting){
                fetchResult()
                }
            },[errors])
     
     useEffect(()=>{
        fetchStaff()
        fetchExamType()
    },[]);


        return (  
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Staff Attendance Summary">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-calendar"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Attendance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Staff Attendance Summary</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row no-print ">
						
                        <div className="col-sm-12">
                    
                        <div className="card z-depth-0">
                            <div className="card-header">
                                <h5><i className="fa fa-edit" ></i> Staff Attendance Summary</h5>
                                <div className="card-header-right">
                                    <ul className="list-unstyled card-option">
                                        <li><i className="feather icon-maximizes full-card"></i></li>
                                        <li><i className="feather icon-minus minimize-card"></i></li>
                                        <li><i className="feather icon-trash-2 close-card"></i></li>
                                    </ul>
                                </div>
                            </div>
                            
                            
                            <div className="card-block">
            

        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
      <section className="col-md-6" >
      <div className="form-group">
        
        <label >Select Staff </label>
        <Select  options={staff&&staff.map((list, idx)=> {
                                       return {key:idx, value: list.code, label:list.staffName, fileNo:list.fileNo }
                                     })
                                }    
                    getOptionLabel={option =>option.label +' '+ option.fileNo}    
        onChange={handleSelect}  name="staff" value={attendance.staff}  />   
                    </div>

</section>


      
<section className="col-md-6">
     <div className="form-group">
          <label> Attendance Term <span style={{color:'red'}}>*</span></label>
          <Select  options={examtype.map((list, id)=>{
             return {key:id, value:list.code, label:list.exam, startDate:list.startDate, endDate:list.endDate}
         })} 
         getOptionLabel={option =>option.label + ' '+ longDate(option.startDate)+" - "+longDate(option.endDate)}               
 onChange={handleSelect} className={errors.examtype ? 'form-control form-control-danger' : ''} name="examtype" value={attendance.examtype} id='exam'  />

 <span style={{color:'red'}}>{errors.examtype && errors.examtype}</span>

 
             </div>
     
     </section>		
     


				</div>	

<div className="row" >
<section className="col-md-12">
	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={handleSubmit} className="btn btn-primary "><i className="fa fa-search"></i> Search Attendance</button>
								</footer>		</section>		
                                </div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>



{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
        <div className="row" >

<table className="table  table-full-width">
       <tbody>
                <tr>
                <td className="text-center" >
                    <img id="viewSchoolLogo2"  onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/headerlogo.png`}   alt={schoolName}  />
 </td>
                </tr>
            </tbody>
       </table>

</div> 
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>Staff Attendance Summary</b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Date Range: <b>{longDate(attendance.fromDate) + ' - ' +longDate(attendance.toDate)}</b></td>
                    <td>Date Printed: <b>{longDate(new Date())} </b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                <th>File No</th>
                    <th>Staff Name</th>
                    <th>Total Attendance</th>
                    <th>Total Present</th>
                    <th>Total Half Day</th>
                    <th>Total Absent</th>
                    <th>Present (%)</th>
                    <th>Half Day (%)</th>
                    <th>Absent (%)</th>
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{st.fileNo}</td>
                    <td>{st.staffName}</td>
                    <td>{Number(st.P) + Number(st.A) + Number(st.H)}</td>
                    <td>{st.P}</td>
                    <td>{st.H}</td>
                    <td>{st.A}</td>
                    <td>{((100*Number(st.P)) / (Number(st.P) + Number(st.A)  + Number(st.H) ))}</td>
                    <td>{((100*Number(st.H)) / (Number(st.P) + Number(st.A)  + Number(st.H) ))}</td>
                    <td>{((100*Number(st.A)) / (Number(st.P) + Number(st.A)  + Number(st.H) ))}</td>
                </tr>):[]}
              </tbody>

        </table>
 </div>	 </div> 

 <div className="row">
        <div className="col-md-12">
        <form method='POST' action={ServerUrl+'/printout/staff_attendance.php?token='+userToken} target='_blank'>
                <input type='hidden' name='result' value ={JSON.stringify(result, null, 2)} />
                <input type='hidden' name='dateRange' value ={longDate(attendance.fromDate) + ' - ' +longDate(attendance.toDate)} />
                <input type='hidden' name='jwtToken' value ={Token} />
        <button type="submit" className="btn btn-inverse pull-right no-print" > <i className="fa fa-print"></i> Print</button>
        
        </form>

        </div></div>

 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(DisplayStudentAttendance) 